"use strict";

export default function routes($stateProvider) {
  "ngInject";

  $stateProvider.state("wanted", {
    url: "/wanted",
    template: require("./wanted.html"),
    controller: "WantedController",
    controllerAs: "wantedCtrl",
  });
}



// WEBPACK FOOTER //
// ./client/app/wanted/wanted.routes.js